/**
 * 注文内容の変更依頼の入力欄の文字数。サーバの検証と画面の入力欄が同じ値を読む
 * (フロントからも import するので、サーバ専用のコードを持ち込まない)。
 */
export const ORDER_CHANGE_REQUEST_MIN = 10;
export const ORDER_CHANGE_REQUEST_MAX = 1000;
